import type { StackProps } from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { textGradient } from "theme/styles";
import { CONFIG } from "config-global";

// ----------------------------------------------------------------------

export function AppVersion({ sx, ...other }: StackProps) {
  return (
    <Box
      display="flex"
      alignItems="center"
      flexDirection="column"
      sx={{ my: 2, textAlign: "center", ...sx }}
      {...other}
    >
      <Typography
        variant="h6"
        sx={(theme) => ({
          ...textGradient(
            `to right, ${theme.vars.palette.secondary.main}, ${theme.vars.palette.warning.main}`
          ),
        })}
      >
        {CONFIG.appVersion}
      </Typography>
    </Box>
  );
}
